//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import dayjs from 'dayjs';

export class ConfigClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    get( cancelToken?: CancelToken): Promise<ConfigResultModel> {
        let url_ = this.baseUrl + "/Config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ConfigResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigResultModel.fromJS(resultData200);
            return Promise.resolve<ConfigResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigResultModel>(null as any);
    }
}

export class HistoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    get(symbol: string | undefined, resolution: string | undefined, countback: number | undefined, from: number | undefined, to: number | undefined, sessionId: string | null | undefined, live: boolean | null | undefined, cancelToken?: CancelToken): Promise<HistoryBarModel> {
        let url_ = this.baseUrl + "/History?";
        if (symbol === null)
            throw new Error("The parameter 'symbol' cannot be null.");
        else if (symbol !== undefined)
            url_ += "Symbol=" + encodeURIComponent("" + symbol) + "&";
        if (resolution === null)
            throw new Error("The parameter 'resolution' cannot be null.");
        else if (resolution !== undefined)
            url_ += "Resolution=" + encodeURIComponent("" + resolution) + "&";
        if (countback === null)
            throw new Error("The parameter 'countback' cannot be null.");
        else if (countback !== undefined)
            url_ += "Countback=" + encodeURIComponent("" + countback) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (live !== undefined && live !== null)
            url_ += "Live=" + encodeURIComponent("" + live) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<HistoryBarModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HistoryBarModel.fromJS(resultData200);
            return Promise.resolve<HistoryBarModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoryBarModel>(null as any);
    }

    getBarsV2(symbol: string | undefined, resolution: string | undefined, countback: number | undefined, from: number | undefined, to: number | undefined, sessionId: string | null | undefined, live: boolean | null | undefined, cancelToken?: CancelToken): Promise<HistoryBarsResult> {
        let url_ = this.baseUrl + "/History/v2?";
        if (symbol === null)
            throw new Error("The parameter 'symbol' cannot be null.");
        else if (symbol !== undefined)
            url_ += "Symbol=" + encodeURIComponent("" + symbol) + "&";
        if (resolution === null)
            throw new Error("The parameter 'resolution' cannot be null.");
        else if (resolution !== undefined)
            url_ += "Resolution=" + encodeURIComponent("" + resolution) + "&";
        if (countback === null)
            throw new Error("The parameter 'countback' cannot be null.");
        else if (countback !== undefined)
            url_ += "Countback=" + encodeURIComponent("" + countback) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (live !== undefined && live !== null)
            url_ += "Live=" + encodeURIComponent("" + live) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBarsV2(_response);
        });
    }

    protected processGetBarsV2(response: AxiosResponse): Promise<HistoryBarsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HistoryBarsResult.fromJS(resultData200);
            return Promise.resolve<HistoryBarsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoryBarsResult>(null as any);
    }
}

export class MarketDataHistoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    getBars(symbol: string | undefined, resolution: string | undefined, countback: number | undefined, from: number | undefined, to: number | undefined, sessionId: string | null | undefined, live: boolean | null | undefined, cancelToken?: CancelToken): Promise<HistoryBarsResult> {
        let url_ = this.baseUrl + "/md/history/v2?";
        if (symbol === null)
            throw new Error("The parameter 'symbol' cannot be null.");
        else if (symbol !== undefined)
            url_ += "Symbol=" + encodeURIComponent("" + symbol) + "&";
        if (resolution === null)
            throw new Error("The parameter 'resolution' cannot be null.");
        else if (resolution !== undefined)
            url_ += "Resolution=" + encodeURIComponent("" + resolution) + "&";
        if (countback === null)
            throw new Error("The parameter 'countback' cannot be null.");
        else if (countback !== undefined)
            url_ += "Countback=" + encodeURIComponent("" + countback) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (live !== undefined && live !== null)
            url_ += "Live=" + encodeURIComponent("" + live) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBars(_response);
        });
    }

    protected processGetBars(response: AxiosResponse): Promise<HistoryBarsResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HistoryBarsResult.fromJS(resultData200);
            return Promise.resolve<HistoryBarsResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoryBarsResult>(null as any);
    }
}

export class MarketDataSearchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    get(query: string | null | undefined, limit: number | null | undefined, exchange: string | null | undefined, cancelToken?: CancelToken): Promise<SymbolSearchResult[]> {
        let url_ = this.baseUrl + "/md/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (exchange !== undefined && exchange !== null)
            url_ += "exchange=" + encodeURIComponent("" + exchange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SymbolSearchResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SymbolSearchResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SymbolSearchResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SymbolSearchResult[]>(null as any);
    }
}

export class MarketDataSymbolsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    get(symbol: string | undefined, cancelToken?: CancelToken): Promise<SymbolResult> {
        let url_ = this.baseUrl + "/md/symbols?";
        if (symbol === null)
            throw new Error("The parameter 'symbol' cannot be null.");
        else if (symbol !== undefined)
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SymbolResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SymbolResult.fromJS(resultData200);
            return Promise.resolve<SymbolResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SymbolResult>(null as any);
    }
}

export class MarketStatusClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    get( cancelToken?: CancelToken): Promise<MarketStatus[]> {
        let url_ = this.baseUrl + "/MarketStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<MarketStatus[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MarketStatus[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarketStatus[]>(null as any);
    }
}

export class MarksClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    get(symbol: string | undefined, from: number | undefined, to: number | undefined, resolution: string | undefined, cancelToken?: CancelToken): Promise<MarkResponse[]> {
        let url_ = this.baseUrl + "/timescale_marks?";
        if (symbol === null)
            throw new Error("The parameter 'symbol' cannot be null.");
        else if (symbol !== undefined)
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (resolution === null)
            throw new Error("The parameter 'resolution' cannot be null.");
        else if (resolution !== undefined)
            url_ += "resolution=" + encodeURIComponent("" + resolution) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<MarkResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarkResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MarkResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkResponse[]>(null as any);
    }
}

export class QuotesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    get(symbols: string[] | undefined, cancelToken?: CancelToken): Promise<QuoteDataModel[]> {
        let url_ = this.baseUrl + "/Quotes?";
        if (symbols === null)
            throw new Error("The parameter 'symbols' cannot be null.");
        else if (symbols !== undefined)
            symbols && symbols.forEach(item => { url_ += "Symbols=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<QuoteDataModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteDataModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QuoteDataModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuoteDataModel[]>(null as any);
    }
}

export class SearchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    get(query: string | null | undefined, limit: number | null | undefined, exchange: string | null | undefined, live: boolean | null | undefined, cancelToken?: CancelToken): Promise<SymbolSearchResult[]> {
        let url_ = this.baseUrl + "/Search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (exchange !== undefined && exchange !== null)
            url_ += "exchange=" + encodeURIComponent("" + exchange) + "&";
        if (live !== undefined && live !== null)
            url_ += "live=" + encodeURIComponent("" + live) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SymbolSearchResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SymbolSearchResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SymbolSearchResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SymbolSearchResult[]>(null as any);
    }
}

export class StrapiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    getAlert( cancelToken?: CancelToken): Promise<StrapiAlertModel> {
        let url_ = this.baseUrl + "/Strapi/alert";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlert(_response);
        });
    }

    protected processGetAlert(response: AxiosResponse): Promise<StrapiAlertModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StrapiAlertModel.fromJS(resultData200);
            return Promise.resolve<StrapiAlertModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StrapiAlertModel>(null as any);
    }

    youtubeUrl( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Strapi/youtube";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processYoutubeUrl(_response);
        });
    }

    protected processYoutubeUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getYoutubeNew( cancelToken?: CancelToken): Promise<StrapiYoutubeModel> {
        let url_ = this.baseUrl + "/Strapi/youtubeNew";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetYoutubeNew(_response);
        });
    }

    protected processGetYoutubeNew(response: AxiosResponse): Promise<StrapiYoutubeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StrapiYoutubeModel.fromJS(resultData200);
            return Promise.resolve<StrapiYoutubeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StrapiYoutubeModel>(null as any);
    }

    getVideos( cancelToken?: CancelToken): Promise<StrapiVideosModel> {
        let url_ = this.baseUrl + "/Strapi/videos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVideos(_response);
        });
    }

    protected processGetVideos(response: AxiosResponse): Promise<StrapiVideosModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StrapiVideosModel.fromJS(resultData200);
            return Promise.resolve<StrapiVideosModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StrapiVideosModel>(null as any);
    }

    getHoags( cancelToken?: CancelToken): Promise<StrapiHoagsModel> {
        let url_ = this.baseUrl + "/Strapi/hoags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHoags(_response);
        });
    }

    protected processGetHoags(response: AxiosResponse): Promise<StrapiHoagsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StrapiHoagsModel.fromJS(resultData200);
            return Promise.resolve<StrapiHoagsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StrapiHoagsModel>(null as any);
    }
}

export class SymbolsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    get(symbol: string | undefined, cancelToken?: CancelToken): Promise<SymbolResult> {
        let url_ = this.baseUrl + "/Symbols?";
        if (symbol === null)
            throw new Error("The parameter 'symbol' cannot be null.");
        else if (symbol !== undefined)
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SymbolResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SymbolResult.fromJS(resultData200);
            return Promise.resolve<SymbolResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SymbolResult>(null as any);
    }
}

export class TimeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    get( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Time";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TradeLogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://chartapi-staging.s2f.projectx.com";

    }

    get(symbolId: string | undefined, cancelToken?: CancelToken): Promise<TradeLogData[]> {
        let url_ = this.baseUrl + "/TradeLog?";
        if (symbolId === null)
            throw new Error("The parameter 'symbolId' cannot be null.");
        else if (symbolId !== undefined)
            url_ += "symbolId=" + encodeURIComponent("" + symbolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TradeLogData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TradeLogData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TradeLogData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradeLogData[]>(null as any);
    }
}

export class ConfigResultModel implements IConfigResultModel {
    supports_search!: boolean;
    supports_group_request!: boolean;
    supports_marks!: boolean;
    supports_timescale_marks!: boolean;
    supports_time!: boolean;
    exchanges!: Exchange[];
    symbol_types!: SymbolType[];
    supported_resolutions!: string[];

    constructor(data?: IConfigResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.exchanges = [];
            this.symbol_types = [];
            this.supported_resolutions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supports_search = _data["supports_search"];
            this.supports_group_request = _data["supports_group_request"];
            this.supports_marks = _data["supports_marks"];
            this.supports_timescale_marks = _data["supports_timescale_marks"];
            this.supports_time = _data["supports_time"];
            if (Array.isArray(_data["exchanges"])) {
                this.exchanges = [] as any;
                for (let item of _data["exchanges"])
                    this.exchanges!.push(Exchange.fromJS(item));
            }
            if (Array.isArray(_data["symbol_types"])) {
                this.symbol_types = [] as any;
                for (let item of _data["symbol_types"])
                    this.symbol_types!.push(SymbolType.fromJS(item));
            }
            if (Array.isArray(_data["supported_resolutions"])) {
                this.supported_resolutions = [] as any;
                for (let item of _data["supported_resolutions"])
                    this.supported_resolutions!.push(item);
            }
        }
    }

    static fromJS(data: any): ConfigResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supports_search"] = this.supports_search;
        data["supports_group_request"] = this.supports_group_request;
        data["supports_marks"] = this.supports_marks;
        data["supports_timescale_marks"] = this.supports_timescale_marks;
        data["supports_time"] = this.supports_time;
        if (Array.isArray(this.exchanges)) {
            data["exchanges"] = [];
            for (let item of this.exchanges)
                data["exchanges"].push(item.toJSON());
        }
        if (Array.isArray(this.symbol_types)) {
            data["symbol_types"] = [];
            for (let item of this.symbol_types)
                data["symbol_types"].push(item.toJSON());
        }
        if (Array.isArray(this.supported_resolutions)) {
            data["supported_resolutions"] = [];
            for (let item of this.supported_resolutions)
                data["supported_resolutions"].push(item);
        }
        return data;
    }
}

export interface IConfigResultModel {
    supports_search: boolean;
    supports_group_request: boolean;
    supports_marks: boolean;
    supports_timescale_marks: boolean;
    supports_time: boolean;
    exchanges: Exchange[];
    symbol_types: SymbolType[];
    supported_resolutions: string[];
}

export class Exchange implements IExchange {
    name!: string;
    value!: string;
    desc!: string;

    constructor(data?: IExchange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.desc = _data["desc"];
        }
    }

    static fromJS(data: any): Exchange {
        data = typeof data === 'object' ? data : {};
        let result = new Exchange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["desc"] = this.desc;
        return data;
    }
}

export interface IExchange {
    name: string;
    value: string;
    desc: string;
}

export class SymbolType implements ISymbolType {
    name!: string;
    value!: string;

    constructor(data?: ISymbolType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SymbolType {
        data = typeof data === 'object' ? data : {};
        let result = new SymbolType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ISymbolType {
    name: string;
    value: string;
}

export class HistoryBarModel implements IHistoryBarModel {
    t!: number[];
    o!: number[];
    c!: number[];
    l!: number[];
    h!: number[];
    v!: number[];
    s!: string;

    constructor(data?: IHistoryBarModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.t = [];
            this.o = [];
            this.c = [];
            this.l = [];
            this.h = [];
            this.v = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["t"])) {
                this.t = [] as any;
                for (let item of _data["t"])
                    this.t!.push(item);
            }
            if (Array.isArray(_data["o"])) {
                this.o = [] as any;
                for (let item of _data["o"])
                    this.o!.push(item);
            }
            if (Array.isArray(_data["c"])) {
                this.c = [] as any;
                for (let item of _data["c"])
                    this.c!.push(item);
            }
            if (Array.isArray(_data["l"])) {
                this.l = [] as any;
                for (let item of _data["l"])
                    this.l!.push(item);
            }
            if (Array.isArray(_data["h"])) {
                this.h = [] as any;
                for (let item of _data["h"])
                    this.h!.push(item);
            }
            if (Array.isArray(_data["v"])) {
                this.v = [] as any;
                for (let item of _data["v"])
                    this.v!.push(item);
            }
            this.s = _data["s"];
        }
    }

    static fromJS(data: any): HistoryBarModel {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryBarModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.t)) {
            data["t"] = [];
            for (let item of this.t)
                data["t"].push(item);
        }
        if (Array.isArray(this.o)) {
            data["o"] = [];
            for (let item of this.o)
                data["o"].push(item);
        }
        if (Array.isArray(this.c)) {
            data["c"] = [];
            for (let item of this.c)
                data["c"].push(item);
        }
        if (Array.isArray(this.l)) {
            data["l"] = [];
            for (let item of this.l)
                data["l"].push(item);
        }
        if (Array.isArray(this.h)) {
            data["h"] = [];
            for (let item of this.h)
                data["h"].push(item);
        }
        if (Array.isArray(this.v)) {
            data["v"] = [];
            for (let item of this.v)
                data["v"].push(item);
        }
        data["s"] = this.s;
        return data;
    }
}

export interface IHistoryBarModel {
    t: number[];
    o: number[];
    c: number[];
    l: number[];
    h: number[];
    v: number[];
    s: string;
}

export class HistoryBarsResult implements IHistoryBarsResult {
    bars!: HistoryBar[];
    code!: HistoryBarsResultCode;

    constructor(data?: IHistoryBarsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.bars = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bars"])) {
                this.bars = [] as any;
                for (let item of _data["bars"])
                    this.bars!.push(HistoryBar.fromJS(item));
            }
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): HistoryBarsResult {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryBarsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bars)) {
            data["bars"] = [];
            for (let item of this.bars)
                data["bars"].push(item.toJSON());
        }
        data["code"] = this.code;
        return data;
    }
}

export interface IHistoryBarsResult {
    bars: HistoryBar[];
    code: HistoryBarsResultCode;
}

export class HistoryBar implements IHistoryBar {
    t!: number;
    o!: number;
    c!: number;
    l!: number;
    h!: number;
    v!: number;
    tv!: number;

    constructor(data?: IHistoryBar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.t = _data["t"];
            this.o = _data["o"];
            this.c = _data["c"];
            this.l = _data["l"];
            this.h = _data["h"];
            this.v = _data["v"];
            this.tv = _data["tv"];
        }
    }

    static fromJS(data: any): HistoryBar {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryBar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["t"] = this.t;
        data["o"] = this.o;
        data["c"] = this.c;
        data["l"] = this.l;
        data["h"] = this.h;
        data["v"] = this.v;
        data["tv"] = this.tv;
        return data;
    }
}

export interface IHistoryBar {
    t: number;
    o: number;
    c: number;
    l: number;
    h: number;
    v: number;
    tv: number;
}

export enum HistoryBarsResultCode {
    Ok = 0,
    NoData = 1,
    Error = 2,
}

export class SymbolSearchResult implements ISymbolSearchResult {
    symbol!: string;
    full_name!: string;
    description!: string;
    ticker!: string;
    exchange!: string;
    type!: string;

    constructor(data?: ISymbolSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.symbol = _data["symbol"];
            this.full_name = _data["full_name"];
            this.description = _data["description"];
            this.ticker = _data["ticker"];
            this.exchange = _data["exchange"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SymbolSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new SymbolSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["symbol"] = this.symbol;
        data["full_name"] = this.full_name;
        data["description"] = this.description;
        data["ticker"] = this.ticker;
        data["exchange"] = this.exchange;
        data["type"] = this.type;
        return data;
    }
}

export interface ISymbolSearchResult {
    symbol: string;
    full_name: string;
    description: string;
    ticker: string;
    exchange: string;
    type: string;
}

export class SymbolResult implements ISymbolResult {
    name!: string;
    symbolId!: string;
    exchangeTraded!: string;
    exchangeListed!: string;
    timezone!: string;
    minmov!: number;
    minmove2!: number;
    pointvalue!: number;
    session!: string;
    subsession_id?: string | undefined;
    subsessions?: SubsessionItem[] | undefined;
    has_daily!: boolean;
    has_intraday!: boolean;
    has_seconds!: boolean;
    has_weekly_and_monthly!: boolean;
    has_ticks!: boolean;
    description!: string;
    type!: string;
    supported_resolutions!: string[];
    intraday_multipliers!: string[];
    seconds_multipliers!: number[];
    pricescale!: number;
    fractional!: boolean;
    ticker!: string;
    data_status!: string;
    s!: string;

    constructor(data?: ISymbolResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.supported_resolutions = [];
            this.intraday_multipliers = [];
            this.seconds_multipliers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.symbolId = _data["symbolId"];
            this.exchangeTraded = _data["exchange-traded"];
            this.exchangeListed = _data["exchange-listed"];
            this.timezone = _data["timezone"];
            this.minmov = _data["minmov"];
            this.minmove2 = _data["minmove2"];
            this.pointvalue = _data["pointvalue"];
            this.session = _data["session"];
            this.subsession_id = _data["subsession_id"];
            if (Array.isArray(_data["subsessions"])) {
                this.subsessions = [] as any;
                for (let item of _data["subsessions"])
                    this.subsessions!.push(SubsessionItem.fromJS(item));
            }
            this.has_daily = _data["has_daily"];
            this.has_intraday = _data["has_intraday"];
            this.has_seconds = _data["has_seconds"];
            this.has_weekly_and_monthly = _data["has_weekly_and_monthly"];
            this.has_ticks = _data["has_ticks"];
            this.description = _data["description"];
            this.type = _data["type"];
            if (Array.isArray(_data["supported_resolutions"])) {
                this.supported_resolutions = [] as any;
                for (let item of _data["supported_resolutions"])
                    this.supported_resolutions!.push(item);
            }
            if (Array.isArray(_data["intraday_multipliers"])) {
                this.intraday_multipliers = [] as any;
                for (let item of _data["intraday_multipliers"])
                    this.intraday_multipliers!.push(item);
            }
            if (Array.isArray(_data["seconds_multipliers"])) {
                this.seconds_multipliers = [] as any;
                for (let item of _data["seconds_multipliers"])
                    this.seconds_multipliers!.push(item);
            }
            this.pricescale = _data["pricescale"];
            this.fractional = _data["fractional"];
            this.ticker = _data["ticker"];
            this.data_status = _data["data_status"];
            this.s = _data["s"];
        }
    }

    static fromJS(data: any): SymbolResult {
        data = typeof data === 'object' ? data : {};
        let result = new SymbolResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["symbolId"] = this.symbolId;
        data["exchange-traded"] = this.exchangeTraded;
        data["exchange-listed"] = this.exchangeListed;
        data["timezone"] = this.timezone;
        data["minmov"] = this.minmov;
        data["minmove2"] = this.minmove2;
        data["pointvalue"] = this.pointvalue;
        data["session"] = this.session;
        data["subsession_id"] = this.subsession_id;
        if (Array.isArray(this.subsessions)) {
            data["subsessions"] = [];
            for (let item of this.subsessions)
                data["subsessions"].push(item.toJSON());
        }
        data["has_daily"] = this.has_daily;
        data["has_intraday"] = this.has_intraday;
        data["has_seconds"] = this.has_seconds;
        data["has_weekly_and_monthly"] = this.has_weekly_and_monthly;
        data["has_ticks"] = this.has_ticks;
        data["description"] = this.description;
        data["type"] = this.type;
        if (Array.isArray(this.supported_resolutions)) {
            data["supported_resolutions"] = [];
            for (let item of this.supported_resolutions)
                data["supported_resolutions"].push(item);
        }
        if (Array.isArray(this.intraday_multipliers)) {
            data["intraday_multipliers"] = [];
            for (let item of this.intraday_multipliers)
                data["intraday_multipliers"].push(item);
        }
        if (Array.isArray(this.seconds_multipliers)) {
            data["seconds_multipliers"] = [];
            for (let item of this.seconds_multipliers)
                data["seconds_multipliers"].push(item);
        }
        data["pricescale"] = this.pricescale;
        data["fractional"] = this.fractional;
        data["ticker"] = this.ticker;
        data["data_status"] = this.data_status;
        data["s"] = this.s;
        return data;
    }
}

export interface ISymbolResult {
    name: string;
    symbolId: string;
    exchangeTraded: string;
    exchangeListed: string;
    timezone: string;
    minmov: number;
    minmove2: number;
    pointvalue: number;
    session: string;
    subsession_id?: string | undefined;
    subsessions?: SubsessionItem[] | undefined;
    has_daily: boolean;
    has_intraday: boolean;
    has_seconds: boolean;
    has_weekly_and_monthly: boolean;
    has_ticks: boolean;
    description: string;
    type: string;
    supported_resolutions: string[];
    intraday_multipliers: string[];
    seconds_multipliers: number[];
    pricescale: number;
    fractional: boolean;
    ticker: string;
    data_status: string;
    s: string;
}

export class SubsessionItem implements ISubsessionItem {
    id!: string;
    description!: string;
    session!: string;
    sessionDisplay!: string;

    constructor(data?: ISubsessionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.session = _data["session"];
            this.sessionDisplay = _data["session-display"];
        }
    }

    static fromJS(data: any): SubsessionItem {
        data = typeof data === 'object' ? data : {};
        let result = new SubsessionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["session"] = this.session;
        data["session-display"] = this.sessionDisplay;
        return data;
    }
}

export interface ISubsessionItem {
    id: string;
    description: string;
    session: string;
    sessionDisplay: string;
}

export class MarketStatus implements IMarketStatus {
    symbolId!: string;
    status!: ExchangeStatus;
    simStatus!: ExchangeStatus;
    openedAt!: dayjs.Dayjs;
    autoLiquidate!: boolean;
    isOpen!: boolean;

    constructor(data?: IMarketStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.symbolId = _data["symbolId"];
            this.status = _data["status"];
            this.simStatus = _data["simStatus"];
            this.openedAt = _data["openedAt"] ? dayjs(_data["openedAt"].toString()) : <any>undefined;
            this.autoLiquidate = _data["autoLiquidate"];
            this.isOpen = _data["isOpen"];
        }
    }

    static fromJS(data: any): MarketStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MarketStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["symbolId"] = this.symbolId;
        data["status"] = this.status;
        data["simStatus"] = this.simStatus;
        data["openedAt"] = this.openedAt ? this.openedAt.toISOString() : <any>undefined;
        data["autoLiquidate"] = this.autoLiquidate;
        data["isOpen"] = this.isOpen;
        return data;
    }
}

export interface IMarketStatus {
    symbolId: string;
    status: ExchangeStatus;
    simStatus: ExchangeStatus;
    openedAt: dayjs.Dayjs;
    autoLiquidate: boolean;
    isOpen: boolean;
}

export enum ExchangeStatus {
    PreOpen = 1,
    Open = 2,
    Closed = 3,
    Halted = 4,
    Suspended = 5,
}

export class MarkResponse implements IMarkResponse {
    id!: number;
    time!: number;
    color?: string | undefined;
    label?: string | undefined;
    imageUrl?: string | undefined;
    tooltip!: string[];
    showLabelWhenImageLoaded!: boolean;

    constructor(data?: IMarkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tooltip = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.time = _data["time"];
            this.color = _data["color"];
            this.label = _data["label"];
            this.imageUrl = _data["imageUrl"];
            if (Array.isArray(_data["tooltip"])) {
                this.tooltip = [] as any;
                for (let item of _data["tooltip"])
                    this.tooltip!.push(item);
            }
            this.showLabelWhenImageLoaded = _data["showLabelWhenImageLoaded"];
        }
    }

    static fromJS(data: any): MarkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["time"] = this.time;
        data["color"] = this.color;
        data["label"] = this.label;
        data["imageUrl"] = this.imageUrl;
        if (Array.isArray(this.tooltip)) {
            data["tooltip"] = [];
            for (let item of this.tooltip)
                data["tooltip"].push(item);
        }
        data["showLabelWhenImageLoaded"] = this.showLabelWhenImageLoaded;
        return data;
    }
}

export interface IMarkResponse {
    id: number;
    time: number;
    color?: string | undefined;
    label?: string | undefined;
    imageUrl?: string | undefined;
    tooltip: string[];
    showLabelWhenImageLoaded: boolean;
}

export class QuoteDataModel implements IQuoteDataModel {
    s!: string;
    n!: string;
    v!: QuoteDataValues;

    constructor(data?: IQuoteDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.v = new QuoteDataValues();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.s = _data["s"];
            this.n = _data["n"];
            this.v = _data["v"] ? QuoteDataValues.fromJS(_data["v"]) : new QuoteDataValues();
        }
    }

    static fromJS(data: any): QuoteDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["s"] = this.s;
        data["n"] = this.n;
        data["v"] = this.v ? this.v.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQuoteDataModel {
    s: string;
    n: string;
    v: QuoteDataValues;
}

export class QuoteDataValues implements IQuoteDataValues {
    ch?: number | undefined;
    chp?: number | undefined;
    lp?: number | undefined;
    ask?: number | undefined;
    bid?: number | undefined;
    spread?: number | undefined;
    open_price?: number | undefined;
    high_price?: number | undefined;
    low_price?: number | undefined;
    prev_close_price?: number | undefined;
    original_name!: string;
    volume?: number | undefined;

    constructor(data?: IQuoteDataValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ch = _data["ch"];
            this.chp = _data["chp"];
            this.lp = _data["lp"];
            this.ask = _data["ask"];
            this.bid = _data["bid"];
            this.spread = _data["spread"];
            this.open_price = _data["open_price"];
            this.high_price = _data["high_price"];
            this.low_price = _data["low_price"];
            this.prev_close_price = _data["prev_close_price"];
            this.original_name = _data["original_name"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): QuoteDataValues {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteDataValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ch"] = this.ch;
        data["chp"] = this.chp;
        data["lp"] = this.lp;
        data["ask"] = this.ask;
        data["bid"] = this.bid;
        data["spread"] = this.spread;
        data["open_price"] = this.open_price;
        data["high_price"] = this.high_price;
        data["low_price"] = this.low_price;
        data["prev_close_price"] = this.prev_close_price;
        data["original_name"] = this.original_name;
        data["volume"] = this.volume;
        return data;
    }
}

export interface IQuoteDataValues {
    ch?: number | undefined;
    chp?: number | undefined;
    lp?: number | undefined;
    ask?: number | undefined;
    bid?: number | undefined;
    spread?: number | undefined;
    open_price?: number | undefined;
    high_price?: number | undefined;
    low_price?: number | undefined;
    prev_close_price?: number | undefined;
    original_name: string;
    volume?: number | undefined;
}

export class StrapiAlertModel implements IStrapiAlertModel {
    data!: Data;
    meta!: Meta;

    constructor(data?: IStrapiAlertModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new Data();
            this.meta = new Meta();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Data.fromJS(_data["data"]) : new Data();
            this.meta = _data["meta"] ? Meta.fromJS(_data["meta"]) : new Meta();
        }
    }

    static fromJS(data: any): StrapiAlertModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrapiAlertModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStrapiAlertModel {
    data: Data;
    meta: Meta;
}

export class Data implements IData {
    id!: number;
    attributes!: Attributes;

    constructor(data?: IData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attributes = new Attributes();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributes = _data["attributes"] ? Attributes.fromJS(_data["attributes"]) : new Attributes();
        }
    }

    static fromJS(data: any): Data {
        data = typeof data === 'object' ? data : {};
        let result = new Data();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IData {
    id: number;
    attributes: Attributes;
}

export class Attributes implements IAttributes {
    message!: string;
    createdAt!: dayjs.Dayjs;
    updatedAt!: dayjs.Dayjs;
    publishedAt!: dayjs.Dayjs;
    color!: string;

    constructor(data?: IAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
            this.publishedAt = _data["publishedAt"] ? dayjs(_data["publishedAt"].toString()) : <any>undefined;
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): Attributes {
        data = typeof data === 'object' ? data : {};
        let result = new Attributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["publishedAt"] = this.publishedAt ? this.publishedAt.toISOString() : <any>undefined;
        data["color"] = this.color;
        return data;
    }
}

export interface IAttributes {
    message: string;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    publishedAt: dayjs.Dayjs;
    color: string;
}

export class Meta implements IMeta {

    constructor(data?: IMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Meta {
        data = typeof data === 'object' ? data : {};
        let result = new Meta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMeta {
}

export class StrapiYoutubeModel implements IStrapiYoutubeModel {
    data?: YoutubeData | undefined;
    meta!: Meta2;

    constructor(data?: IStrapiYoutubeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.meta = new Meta2();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? YoutubeData.fromJS(_data["data"]) : <any>undefined;
            this.meta = _data["meta"] ? Meta2.fromJS(_data["meta"]) : new Meta2();
        }
    }

    static fromJS(data: any): StrapiYoutubeModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrapiYoutubeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStrapiYoutubeModel {
    data?: YoutubeData | undefined;
    meta: Meta2;
}

export class YoutubeData implements IYoutubeData {
    id!: number;
    attributes?: Attributes2 | undefined;

    constructor(data?: IYoutubeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributes = _data["attributes"] ? Attributes2.fromJS(_data["attributes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): YoutubeData {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IYoutubeData {
    id: number;
    attributes?: Attributes2 | undefined;
}

export class Attributes2 implements IAttributes2 {
    stream_value?: string | undefined;
    createdAt!: dayjs.Dayjs;
    updatedAt!: dayjs.Dayjs;
    online!: boolean;

    constructor(data?: IAttributes2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stream_value = _data["stream_value"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
            this.online = _data["online"];
        }
    }

    static fromJS(data: any): Attributes2 {
        data = typeof data === 'object' ? data : {};
        let result = new Attributes2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stream_value"] = this.stream_value;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["online"] = this.online;
        return data;
    }
}

export interface IAttributes2 {
    stream_value?: string | undefined;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    online: boolean;
}

export class Meta2 implements IMeta2 {
    pagination!: Pagination;

    constructor(data?: IMeta2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pagination = new Pagination();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : new Pagination();
        }
    }

    static fromJS(data: any): Meta2 {
        data = typeof data === 'object' ? data : {};
        let result = new Meta2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMeta2 {
    pagination: Pagination;
}

export class Pagination implements IPagination {
    page!: number;
    pageSize!: number;
    pageCount!: number;
    total!: number;

    constructor(data?: IPagination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.pageCount = _data["pageCount"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): Pagination {
        data = typeof data === 'object' ? data : {};
        let result = new Pagination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["pageCount"] = this.pageCount;
        data["total"] = this.total;
        return data;
    }
}

export interface IPagination {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
}

export class StrapiVideosModel implements IStrapiVideosModel {
    data!: Datum[];
    meta!: Meta2;

    constructor(data?: IStrapiVideosModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.meta = new Meta2();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Datum.fromJS(item));
            }
            this.meta = _data["meta"] ? Meta2.fromJS(_data["meta"]) : new Meta2();
        }
    }

    static fromJS(data: any): StrapiVideosModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrapiVideosModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStrapiVideosModel {
    data: Datum[];
    meta: Meta2;
}

export class Datum implements IDatum {
    id!: number;
    attributes!: DatumAttributes;

    constructor(data?: IDatum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attributes = new DatumAttributes();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributes = _data["attributes"] ? DatumAttributes.fromJS(_data["attributes"]) : new DatumAttributes();
        }
    }

    static fromJS(data: any): Datum {
        data = typeof data === 'object' ? data : {};
        let result = new Datum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDatum {
    id: number;
    attributes: DatumAttributes;
}

export class DatumAttributes implements IDatumAttributes {
    youtubeLink!: string;
    image!: Image;

    constructor(data?: IDatumAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.image = new Image();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.youtubeLink = _data["youtubeLink"];
            this.image = _data["image"] ? Image.fromJS(_data["image"]) : new Image();
        }
    }

    static fromJS(data: any): DatumAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new DatumAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["youtubeLink"] = this.youtubeLink;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDatumAttributes {
    youtubeLink: string;
    image: Image;
}

export class Image implements IImage {
    data!: Data2;

    constructor(data?: IImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new Data2();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Data2.fromJS(_data["data"]) : new Data2();
        }
    }

    static fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImage {
    data: Data2;
}

export class Data2 implements IData2 {
    id!: number;
    attributes!: DataAttributes;

    constructor(data?: IData2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attributes = new DataAttributes();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributes = _data["attributes"] ? DataAttributes.fromJS(_data["attributes"]) : new DataAttributes();
        }
    }

    static fromJS(data: any): Data2 {
        data = typeof data === 'object' ? data : {};
        let result = new Data2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IData2 {
    id: number;
    attributes: DataAttributes;
}

export class DataAttributes implements IDataAttributes {
    name!: string;
    alternativeText!: any;
    caption!: any;
    width!: number;
    height!: number;
    formats!: Formats;
    hash!: string;
    ext!: string;
    mime!: string;
    size!: number;
    url!: string;
    previewUrl!: any;
    provider!: string;
    provider_metadata!: any;
    createdAt!: dayjs.Dayjs;
    updatedAt!: dayjs.Dayjs;

    constructor(data?: IDataAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formats = new Formats();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.alternativeText = _data["alternativeText"];
            this.caption = _data["caption"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.formats = _data["formats"] ? Formats.fromJS(_data["formats"]) : new Formats();
            this.hash = _data["hash"];
            this.ext = _data["ext"];
            this.mime = _data["mime"];
            this.size = _data["size"];
            this.url = _data["url"];
            this.previewUrl = _data["previewUrl"];
            this.provider = _data["provider"];
            this.provider_metadata = _data["provider_metadata"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DataAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new DataAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["alternativeText"] = this.alternativeText;
        data["caption"] = this.caption;
        data["width"] = this.width;
        data["height"] = this.height;
        data["formats"] = this.formats ? this.formats.toJSON() : <any>undefined;
        data["hash"] = this.hash;
        data["ext"] = this.ext;
        data["mime"] = this.mime;
        data["size"] = this.size;
        data["url"] = this.url;
        data["previewUrl"] = this.previewUrl;
        data["provider"] = this.provider;
        data["provider_metadata"] = this.provider_metadata;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDataAttributes {
    name: string;
    alternativeText: any;
    caption: any;
    width: number;
    height: number;
    formats: Formats;
    hash: string;
    ext: string;
    mime: string;
    size: number;
    url: string;
    previewUrl: any;
    provider: string;
    provider_metadata: any;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
}

export class Formats implements IFormats {
    thumbnail!: Large;
    large!: Large;
    medium!: Large;
    small!: Large;

    constructor(data?: IFormats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.thumbnail = new Large();
            this.large = new Large();
            this.medium = new Large();
            this.small = new Large();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thumbnail = _data["thumbnail"] ? Large.fromJS(_data["thumbnail"]) : new Large();
            this.large = _data["large"] ? Large.fromJS(_data["large"]) : new Large();
            this.medium = _data["medium"] ? Large.fromJS(_data["medium"]) : new Large();
            this.small = _data["small"] ? Large.fromJS(_data["small"]) : new Large();
        }
    }

    static fromJS(data: any): Formats {
        data = typeof data === 'object' ? data : {};
        let result = new Formats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        data["large"] = this.large ? this.large.toJSON() : <any>undefined;
        data["medium"] = this.medium ? this.medium.toJSON() : <any>undefined;
        data["small"] = this.small ? this.small.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFormats {
    thumbnail: Large;
    large: Large;
    medium: Large;
    small: Large;
}

export class Large implements ILarge {
    name!: string;
    hash!: string;
    ext!: string;
    mime!: string;
    path!: any;
    width!: number;
    height!: number;
    size!: number;
    url!: string;

    constructor(data?: ILarge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.hash = _data["hash"];
            this.ext = _data["ext"];
            this.mime = _data["mime"];
            this.path = _data["path"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.size = _data["size"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): Large {
        data = typeof data === 'object' ? data : {};
        let result = new Large();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["hash"] = this.hash;
        data["ext"] = this.ext;
        data["mime"] = this.mime;
        data["path"] = this.path;
        data["width"] = this.width;
        data["height"] = this.height;
        data["size"] = this.size;
        data["url"] = this.url;
        return data;
    }
}

export interface ILarge {
    name: string;
    hash: string;
    ext: string;
    mime: string;
    path: any;
    width: number;
    height: number;
    size: number;
    url: string;
}

export class StrapiHoagsModel implements IStrapiHoagsModel {
    data!: Datum2[];
    meta!: Meta2;

    constructor(data?: IStrapiHoagsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.meta = new Meta2();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Datum2.fromJS(item));
            }
            this.meta = _data["meta"] ? Meta2.fromJS(_data["meta"]) : new Meta2();
        }
    }

    static fromJS(data: any): StrapiHoagsModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrapiHoagsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStrapiHoagsModel {
    data: Datum2[];
    meta: Meta2;
}

export class Datum2 implements IDatum2 {
    id!: number;
    attributes!: HoagsAttributes;

    constructor(data?: IDatum2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.attributes = new HoagsAttributes();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attributes = _data["attributes"] ? HoagsAttributes.fromJS(_data["attributes"]) : new HoagsAttributes();
        }
    }

    static fromJS(data: any): Datum2 {
        data = typeof data === 'object' ? data : {};
        let result = new Datum2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDatum2 {
    id: number;
    attributes: HoagsAttributes;
}

export class HoagsAttributes implements IHoagsAttributes {
    symbol!: string;
    lastWeekHigh!: number;
    wkoHigh!: number;
    wkoLow!: number;
    settlement!: number;
    yesterdayVAH!: number;
    yesterdayHigh!: number;
    createdAt!: dayjs.Dayjs;
    updatedAt!: dayjs.Dayjs;
    yesterdayVPOC!: number;
    yesterdayVAL!: number;
    yesterdayLow!: number;
    lastWeekLow!: number;

    constructor(data?: IHoagsAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.symbol = _data["Symbol"];
            this.lastWeekHigh = _data["LastWeekHigh"];
            this.wkoHigh = _data["WkoHigh"];
            this.wkoLow = _data["WkoLow"];
            this.settlement = _data["Settlement"];
            this.yesterdayVAH = _data["YesterdayVAH"];
            this.yesterdayHigh = _data["YesterdayHigh"];
            this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : <any>undefined;
            this.yesterdayVPOC = _data["YesterdayVPOC"];
            this.yesterdayVAL = _data["YesterdayVAL"];
            this.yesterdayLow = _data["YesterdayLow"];
            this.lastWeekLow = _data["LastWeekLow"];
        }
    }

    static fromJS(data: any): HoagsAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new HoagsAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Symbol"] = this.symbol;
        data["LastWeekHigh"] = this.lastWeekHigh;
        data["WkoHigh"] = this.wkoHigh;
        data["WkoLow"] = this.wkoLow;
        data["Settlement"] = this.settlement;
        data["YesterdayVAH"] = this.yesterdayVAH;
        data["YesterdayHigh"] = this.yesterdayHigh;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["YesterdayVPOC"] = this.yesterdayVPOC;
        data["YesterdayVAL"] = this.yesterdayVAL;
        data["YesterdayLow"] = this.yesterdayLow;
        data["LastWeekLow"] = this.lastWeekLow;
        return data;
    }
}

export interface IHoagsAttributes {
    symbol: string;
    lastWeekHigh: number;
    wkoHigh: number;
    wkoLow: number;
    settlement: number;
    yesterdayVAH: number;
    yesterdayHigh: number;
    createdAt: dayjs.Dayjs;
    updatedAt: dayjs.Dayjs;
    yesterdayVPOC: number;
    yesterdayVAL: number;
    yesterdayLow: number;
    lastWeekLow: number;
}

export class TradeLogData implements ITradeLogData {
    symbolId!: string;
    price!: number;
    timestamp!: dayjs.Dayjs;
    type!: TradeLogType;
    volume!: number;

    constructor(data?: ITradeLogData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.symbolId = _data["symbolId"];
            this.price = _data["price"];
            this.timestamp = _data["timestamp"] ? dayjs(_data["timestamp"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): TradeLogData {
        data = typeof data === 'object' ? data : {};
        let result = new TradeLogData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["symbolId"] = this.symbolId;
        data["price"] = this.price;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["volume"] = this.volume;
        return data;
    }
}

export interface ITradeLogData {
    symbolId: string;
    price: number;
    timestamp: dayjs.Dayjs;
    type: TradeLogType;
    volume: number;
}

export enum TradeLogType {
    Buy = 0,
    Sell = 1,
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}